export default function Machines_C_4 (number = 1) {
  return {
    name: '抽水机',
    icon: '/static/img/machines/c4.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_C/Machines_C_4.js